module.exports = __webpack_public_path__ + "img/logo-jupa-BE.88314b02.png";